<template>
  <bvue-ui-view :scroll="true">
    <div class="w-full">
      <button @click="$router.go(-1)" class="link flex items-center mb-8">
         <i class="material-icons">arrow_back</i>
         <label>Volver</label>
      </button>
    </div>
    <h3>Estado:</h3>
    <h4 v-html="state"></h4>
    <button class="link" @click="cancel()" v-if="transaction.state === 'unpaid'">Cancelar la transacción</button>
    <button class="link" @click="remove()" v-if="transaction.state === 'paid'">Eliminar transacción</button>
    <button class="link" @click="refund()" v-if="transaction.state === 'paid'" :disabled="refunding">
      {{ refunding ? 'Procesando...' : 'Devolver pago' }}
    </button>
    <h3 class="mt-4">Fecha:</h3>
    <h4>{{date}}</h4>
    <h3 class="mt-4">Precio:</h3>
    <h4>Ha pagado <b>{{transaction.amount}} $</b> por {{seeds}}</h4>
    <h3 class="mt-4">Usuario:</h3>
    <h4>{{owner.name}}</h4>
    <button @click="showProfile()" class="link flex items-center mb-8">
      <label>Ver Perfil</label>
      <i class="material-icons ml-4">arrow_forward</i>
    </button>
    <h3>ID de Usuario:</h3>
    <h4>{{this.transaction.userId}}</h4>
    <h2 class="mt-4">Reserva:</h2>
    <h4>{{reserve.name}}</h4>
    <h2 class="mt-4">Datos del pago:</h2>
    <pre id="json">{{JSON.stringify(transaction.paymentez || transaction.paypal, null, "\t")}}</pre>
  </bvue-ui-view>
</template>

<script>

import firebase from '@/firebase'

export default {
  name: 'TransactionDetails',
  data() {
    return {
      transactionId: null,
      transaction: {},
      owner: {},
      refunding: false,
      // Guardar referencia al unsubscribe del listener
      _unsubscribe: null,
    }
  },
  destroyed() {
    // Limpiar listener de Firestore
    if (this._unsubscribe) {
      this._unsubscribe()
      this._unsubscribe = null
    }
  },
  methods: {
    showProfile() {
      this.$router.push('/profile/'+this.transaction.userId)
    },
    cancel() {
      const msg = 'Al cancelar una transacción sin pagar, las semillas reservadas vuelven a estar disponibles. Si el pago se realizara finalmente podría hacer que otra transacción use las mismas semillas. ¿Estás seguro?'
      const confirmed = confirm(msg);
      if (confirmed) {
        firebase.firestore.collection('transactions').doc(this.transactionId).update({
          state: 'cancelled',
          updatedAt: new Date().getTime(),
        })
      }
    },
    async remove() {
      const msg = 'Si eliminas una transacción se le quitarán las semillas y árboles plantados con las mismas. Este proceso no es reversible. ¿Estás seguro?'
      const confirmed = confirm(msg);
      if (confirmed) {
        const seeds = this.transaction.seeds || []
        var promises = []
        seeds.forEach(seedId => {
          promises.push(firebase.firestore.collection('reserves').doc(this.transaction.reserveId).collection('seeds').doc(seedId).update({ownerId: null, planted: null}))
        });
        await Promise.all(promises)
        firebase.firestore.collection('transactions').doc(this.transactionId).update({
          state: 'removed',
          updatedAt: new Date().getTime(),
        })
      }
    },
    async refund() {
      const msg = '¿Estás seguro de que quieres devolver el pago? Las semillas y árboles plantados serán liberados.'
      const confirmed = confirm(msg);
      if (!confirmed) return

      this.refunding = true
      try {
        // Obtener el ID token del usuario actual para autenticar la petición
        const idToken = await firebase.auth.currentUser.getIdToken()

        // Llamar a la Cloud Function refundTransaction (server-side)
        // Las server keys de la pasarela de pago nunca salen del servidor
        const functionsUrl = process.env.NODE_ENV === 'production'
          ? 'https://us-central1-red-forestal.cloudfunctions.net'
          : 'http://localhost:5001/red-forestal/us-central1'

        const response = await fetch(`${functionsUrl}/refundTransaction`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
          },
          body: JSON.stringify({
            transactionId: this.transactionId,
          }),
        })

        const result = await response.json()

        if (result.success) {
          alert('Refund realizado con éxito')
        } else {
          alert('Error al hacer el refund: ' + (result.detail || result.error || 'Error desconocido'))
        }
      } catch (error) {
        console.error('Error processing refund:', error)
        alert('Error al procesar el refund: ' + error.message)
      } finally {
        this.refunding = false
      }
    }
  },
  computed: {
    seeds() {
      if (this.transaction) {
        const seeds = this.transaction.seeds
        if (seeds) {
          const count = seeds.length
          return count == 1 ? '1 semilla' : `${count} semillas`
        }
      } 
      return '0 semillas'
    },
    state() {
      if (this.transaction) {
        const value = this.transaction.state
        if (value === 'error') {
          return `<span class="text-red">${value}</span>`
        } else if (value === 'paid') {
          return `<span class="text-green">${value}</span>`
        } else if (value === 'unpaid') {
          return `<span class="text-blue">${value}</span>`
        } else if (value === 'removed') {
          return `<span class="text-orange">${value}</span>`
        } else if (value === 'refunded') {
          return `<span class="text-purple">${value}</span>`
        } else if (value === 'serial') {
          return `<span class="text-teal">${value}</span>`
        }
        return value
      }
      return ''
    },
    date() {
      if (this.transaction) {
        const date = new Date(this.transaction.createdAt)
        return date.toLocaleDateString() + ' a las ' + date.toLocaleTimeString(undefined, {hour: '2-digit',minute: '2-digit'})
      }
      return ''
    },
    reserve() {
      if (this.transaction) {
        return this.$store.state.reserves.items[this.transaction.reserveId] || {}
      }
      return {}
    },
  },
  async created() {
    const params = this.$route.params
    this.transactionId = params.id

    this._unsubscribe = firebase.firestore.collection('transactions').doc(this.transactionId).onSnapshot((doc) => {
        if (doc.exists) {
          this.transaction = doc.data()
          firebase.firestore.collection('profiles').doc(this.transaction.userId).get().then((doc) => {
            if (doc.exists) {
              this.owner = doc.data()
            }
          })
        }
    });
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/TransactionDetails.vue